{
  "version": 1,
  "asset_id": "90b03654-ddcc-4c15-a960-1e2505ef6287",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/90b03654-ddcc-4c15-a960-1e2505ef6287/palworld-plush-chillet-ebay.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/90b03654-ddcc-4c15-a960-1e2505ef6287/palworld-plush-chillet-ebay.webp",
  "original_filename": "palworld-plush-chillet-ebay.webp",
  "size": 32532,
  "content_type": "image/webp",
  "created_at": "2026-09-01T00:45:23Z"
}
